import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {LocationEntity} from '../Entities/LocationEntity.js'

export class ProvincesListLocationValueObject extends ValueObject {
  #provinces

  constructor({provinces}) {
    super()
    this.#provinces = provinces
  }

  static createFromListingApi({provinceIds}) {
    const provincesById = ConfigContext.get('provincesById')

    return new ProvincesListLocationValueObject({
      provinces: provinceIds.map(id => LocationEntity.createFromLiterals({id, name: provincesById[id].label}))
    })
  }

  get provinces() {
    return this.#provinces.map(province => province.value)
  }

  get value() {
    return this.provinces
  }
}
